<template>
    <div class="breadcrumbs">
      <ul class="breadcrumbs__path">
          <li
              v-for="(breadcrumb, index) in pathMergedWithDynamicRoutes"
              :key="index"
              class="breadcrumbs__link"
          >
              <span
                v-if="breadcrumb.link.disabled"
                class="help-text"
              >
                  {{ breadcrumb.title }}
              </span>
              <div
                   v-else
              >
                  <router-link
                          :to="breadcrumb.link"
                          class="help-text link"
                  >
                    {{ breadcrumb.title}}
                  </router-link>
                  <span class="breadcrumbs__angle"> > </span>
              </div>
          </li>
      </ul>
    </div>
</template>

<script>
export default {
    name: 'Breadcrumbs',
    computed: {
        breadcrumbsPath() {
            return this.$route.meta.breadcrumbs
        },
        dynamicRoutes() {
            return this.$store.state.breadcrumbsDynamicRoutes
        },
        pathMergedWithDynamicRoutes() {
            return this.breadcrumbsPath.map(path => this.formatDynamicRoute(path))
        }
    },
    methods: {
      formatDynamicRoute(route) {
          if (!route.dynamic) {
              return route
          }

          const mergedRoute = Object.assign({}, route)
          mergedRoute.link.params = this.dynamicRoutes[route.link.name]

          return mergedRoute
      }
    }
}
</script>

<style lang="sass" scoped>
    .breadcrumbs__path
        display: flex
        list-style: none
        margin: 0
        padding: 0

    .breadcrumbs__link
        margin-right: gridSteps(0.5)
</style>